import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { Mui } from 'components';
import { generateExport } from 'components/common/DataTable/utils';

const SPINNER_DELAY_MS = 150;

function ExportButton({ fileName, data, options, children, ...buttonProps }) {
  const [isExporting, setIsExporting] = useState(false);
  const spinnerTimeout = useRef();
  const running = useRef(false);

  if (!data || data.length <= 1) return null;

  const handleExport = async () => {
    if (running.current) return;
    running.current = true;
    spinnerTimeout.current = setTimeout(() => setIsExporting(true), SPINNER_DELAY_MS);
    try {
      await generateExport(fileName, data, options);
    } finally {
      clearTimeout(spinnerTimeout.current);
      setIsExporting(false);
      running.current = false;
    }
  };

  const { style: buttonStyle, ...restButtonProps } = buttonProps;

  return (
    <Mui.Button
      startIcon={<Mui.Icon>get_app</Mui.Icon>}
      variant="outlined"
      color="primary"
      {...restButtonProps}
      style={buttonStyle}
      loading={isExporting}
      disabled={isExporting || buttonProps.disabled}
      onClick={handleExport}>
      {children || 'Exportar'}
    </Mui.Button>
  );
}

ExportButton.propTypes = {
  fileName: PropTypes.string.isRequired,
  data: PropTypes.array,
  options: PropTypes.object,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

ExportButton.defaultProps = {
  options: { type: 'array', skipHeader: 1 },
};

export default ExportButton;
